import React from 'react';
import { IGenericIconProps } from './types';
import theme from '../../../theme';

const CheckMarkOutlined: React.FC<IGenericIconProps> = ({
    width = 20,
    height = 20,
    strokeColor = theme.colors.loopEmerald,
    strokeWidth = 1.5
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M2.5 9.35963L7.75 15.0007L17.5 5.83398"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export { CheckMarkOutlined };
